module.exports = __webpack_public_path__ + "static/media/logonewlogin.1176748d.PNG";